import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { EntityCardBlueprint } from '@backstage/plugin-catalog-react/alpha';
import type { Entity } from '@backstage/catalog-model';
import { VALIDATION_STATUS_ANNOTATION, markerFor } from './ValidationStatusBanner';

// E8 — entity-card extension that shows the non-dismissible "UNVALIDATED" banner
// on AI-Asset-Library entities that are not Blessed. The `filter` guarantees the
// card only mounts when there is a marker to show, so a Blessed (`effective`)
// entry shows nothing — the marker means something.
const validationStatusCard = EntityCardBlueprint.make({
  name: 'ai-library-validation-status',
  params: {
    filter: (entity: Entity) =>
      !!markerFor(entity.metadata.annotations?.[VALIDATION_STATUS_ANNOTATION]),
    loader: async () => {
      const { ValidationStatusBanner } = await import('./ValidationStatusBanner');
      return <ValidationStatusBanner />;
    },
  },
});

export const catalogMarkersModule = createFrontendModule({
  pluginId: 'catalog',
  extensions: [validationStatusCard],
});
